import { storeToRefs } from 'pinia';
import { useTranslationsStore } from '@/stores/useTranslationsStore';

export function useTranslation() {
	const { translations } = storeToRefs(useTranslationsStore());

	const t = (key) => {
		if (translations.value?.[key] !== undefined) {
			return translations.value[key];
		}
		if (key === 'disclaimer2') {
			return undefined;
		}
		return `{${key}}`;
	};

	return { t };
}
